module.exports = __webpack_public_path__ + "static/media/img-test1.81ff3786.png";